import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FiMoreHorizontal } from "react-icons/fi";
import { Dropdown } from 'react-bootstrap';
import CalendarEditModal from 'components/Calendars/CalendarEditModal';
import { showModal, hideModal } from "actions/modalActions";
import * as calendarsActions from 'actions/calendarsActions';
import { calendarsService } from "services";
import { errorFormating } from "utils/utils";
import DataTable from "components/DataTable";
import { withTranslation } from 'react-i18next';
import { toastr } from 'react-redux-toastr';

class CalendarList extends Component {
	constructor(props) {
		super(props);
		this.closeModal = this.closeModal.bind(this);
		this.openEditCalendarModal = this.openEditCalendarModal.bind(this);
		this.openDeleteCalendarModal = this.openDeleteCalendarModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
	}

	closeModal() {
		this.props.hideModal()
	}

	openEditCalendarModal(calendar) {
		this.props.showModal({
			open: true,
			title: this.props.system ? this.props.t('calendars.system.editCalendar') : this.props.t('calendars.editCalendar'),
			style: { width: '670px' },
			content: <CalendarEditModal system={this.props.system} calendar={calendar} handleClose={this.closeModal} />,
			closeModal: this.closeModal
		}, 'edit')
	}

	openPushCalendarModal = (calendar) => {
		this.props.showModal({
			open: true,
			title: this.props.t('calendars.system.pushTitle'),
			style: { width: '450px' },
			message: this.props.t('calendars.system.pushConfirmation', { name: calendar.name }),
			confirmText: this.props.t('calendars.system.push'),
			loadingText: this.props.t('calendars.system.pushing'),
			confirmAction: () => this.pushCalendar(calendar.id),
			closeModal: this.closeModal,
		}, 'confirm');
	}

	pushCalendar = async (id) => {
		const response = await calendarsService.pushSystem(id);

		if (!response.ok) {
			const textError = errorFormating(response);
			this.closeModal();
			this.openAlertModal(this.props.t('calendars.system.pushError'), textError.general || textError.id);
			return;
		}

		this.closeModal();
		toastr.success(
			this.props.t('common.success'),
			this.props.t('calendars.system.pushStarted'),
			{ timeOut: 10000 }
		);
	}

	openDeleteCalendarModal(idCalendar) {
		this.props.showModal({
			open: true,
			title: this.props.t('calendars.deleteCalendar'),
			style: { width: '400px' },
			message: this.props.t('calendars.deleteConfirmation'),
			deleteAction: () => this.confirmDelete(idCalendar),
			closeModal: this.closeModal
		}, 'delete')
	}

	openAlertModal(title, message) {
		this.props.showModal({
			open: true,
			title: title,
			style: { width: '400px' },
			message: message,
			closeModal: this.closeModal
		}, 'alert')
	}

	confirmDelete = async (idCalendar) => {
		const response = await calendarsService.remove(idCalendar);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(this.props.t('calendars.deleteError'), textError.id);
		}
		else {
			this.props.getAllCalendars();
			this.closeModal();
		}
	}

	cloneCalendar = async (idCalendar) => {
		const response = await calendarsService.clone(idCalendar);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(this.props.t('calendars.cloneError'), textError.id || this.props.t('calendars.cloneErrorMsg'));
		}
		else {
			this.props.getAllCalendars();
			this.closeModal();
		}
	}

	getCalendarActions = (calendar) => (
		<Dropdown>
			<Dropdown.Toggle variant="action"><FiMoreHorizontal /></Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item as="button" onClick={() => this.openEditCalendarModal(calendar)}>{this.props.t('common.edit')}</Dropdown.Item>
				{this.props.system ? (
					<Dropdown.Item as="button" onClick={() => this.openPushCalendarModal(calendar)}>
						{this.props.t('calendars.system.push')}
					</Dropdown.Item>
				) : (
					<>
						<Dropdown.Item as="button" onClick={() => this.cloneCalendar(calendar.id)}>{this.props.t('calendars.clone')}</Dropdown.Item>
						<Dropdown.Item as="button" onClick={() => this.openDeleteCalendarModal(calendar.id)}>{this.props.t('common.delete')}</Dropdown.Item>
					</>
				)}
			</Dropdown.Menu>
		</Dropdown>
	);

	getCalendarColumns = () => [
		{
			key: "name",
			header: this.props.t('common.name'),
			render: (calendar) => (
				<button
					type="button"
					className="btn-transparent btn-editable"
					onClick={() => this.openEditCalendarModal(calendar)}
				>
					{calendar.name}
				</button>
			),
		},
		{
			key: "description",
			header: this.props.t('common.description'),
			render: (calendar) =>
				calendar.description != null && calendar.description !== ""
					? calendar.description
					: "—",
		},
	];

	render() {
		const calendars = (this.props.system ? this.props.system_calendars : this.props.calendars) || [];

		return (
			<DataTable
				tableClassName="table-calendars table-hover"
				tableStyle={{ backgroundColor: "#ffffff" }}
				columns={this.getCalendarColumns()}
				rows={calendars}
				rowKey={(row) => row.id}
				emptyMessage={this.props.t('common.noResults')}
				actionsColumn={{
					render: (calendar) => this.getCalendarActions(calendar),
					className: "td-actions",
				}}
			/>
		);
	}
}


const mapStateToProps = (reducers) => {
	return reducers.calendarsReducer;
};

const mapDispatchToProps = dispatch => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }))
	},
	getAllCalendars: (q) => dispatch(calendarsActions.getAllCalendars(q)),
})


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CalendarList))
